const CARESPACES_URL = "https://app.craniometrix.com/carespaces";
const CARESPACE_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function carespaceRecordUrl(id: string) {
  return CARESPACE_ID_PATTERN.test(id) ? `${CARESPACES_URL}/${id}` : undefined;
}

export function navigatorCarespacesUrl(userId: string) {
  if (!CARESPACE_ID_PATTERN.test(userId)) return undefined;
  const filters = encodeURIComponent(JSON.stringify({ carenavigatorUserId: userId }));
  return `${CARESPACES_URL}?filters=${filters}`;
}
